import { ISoundConfig } from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

/**
 * Created by Ning Jiang on 11/24/2016.
 */

export class SoundConfig implements ISoundConfig {

    public static instance:SoundConfig = new SoundConfig();

    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";

    FS_GAME_AMBIANCE:string = "background-music-fs";
    FS_TOTAL_WIN:string = "fsEnds";
    FS_INTRO:string = "fsIntro";

    INTENSITY_0_GAME_AMBIANCE:string = "background-music-main";

    REELS_QUICK_SPIN_START:string = "spinStartGuitar1";
    START_GAME_AMBIANCE_CROSS_FADE_DURATION:number = 0;
    REELS_SPIN_START:string[] = ["spinStart"];
    REELS_SPINNING:string = "reelsSpinning";
    REELS_DEFAULT_STOP:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5", "reelLanding6"];

    ANTICIPATION_START:string = "anticipation";
    ANTICIPATION_BIG:string = "anticipationBig";
    ANTICIPATION_END:string = "anticipationEnds";
    ANTICIPATION_PLING:string = "anticipationBigEnds";
    SCATTER_LAND:string = "scatter";
    SCATTER_LAND2:string = "scatter3";
    SCATTER_LAND3:string = "scatter4";

    BETLINE_SHAKE:string =  "betlineShake";
    BETLINE_WIN:string = "betline";
    BETLINE_WIN_ALL:string = "betlineWin";
    NORMAL_TOTAL_WINS:string[] = ["winTiny","winSmall","winMedium","winLarge"];
    NORMAL_COUNTUP:string = "countup";
    NORMAL_COUNTUP_END:string = "countupEnds";

    COUNTER_6X6:string = "6x6Countup";

    BIG_WIN_LVL:string[] = ["bigwinLevel1", "bigwinLevel2", "bigwinLevel3", "bigwinLevel4"];
    BIG_WIN_MUSIC:string = "bigwin";
    BIG_WIN_MUSIC_END:string = "bigwinEnds";
    BIG_WIN_COUNT:string = "bigwinCountup";
    BIG_WIN_INITIAL:string = "bigwinInitialWin";
    BIG_WIN_COUNT_END:string = "countupEnds";

    XWAYS_EXPAND_WIN:string = "xwaysExpandWin";
    XWAYS_EXPAND_WIN_SUPER:string = "xwaysSuperExpandWin";
    XWAYS_EXPAND_NO_WIN:string = "xwaysExpandNoWin";
    XWAYS_EXPAND_DEAD:string = "xwaysExpandDead";

    XWAYS_LAND:string = "xwaysLandning";
    XWAYS_LAND_DEAD:string = "xwaysLandningDead";

    XWAYS_WIN:string = "xwaysWin";

    XWAYS_WIN_DELAY:number = 0.3; // 0.2s


    WILD_LAND:string = "wildLanding";
    WILD_MOVES:string = "fsWildsMove";
    WILD_LOCKS:string = "fsWildLock";

    WILD_EXPANDS_1:string = "wildExpand1";
    WILD_EXPANDS_2:string = "wildExpand2";
    WILD_EXPANDS_QUICK:string = "wildExpandQuick";

    TRAIN_MOVES:string = "train";
    TRAIN_BRAKE:string = "trainBrake";
    TRAIN_OPEN_CLOSE:string = "trainOpenClose";

    RESPIN_INTRO:string = "respinIntro";
    RESPIN_MUSIC:string = "respinMusic";
    RESPIN_END:string = "respinEnds";

    FENCE_EXPLODE:string = "fenceExplode";

    CHAIN1:string = "chain1";
    CHAIN2:string = "chain2";

    BLACK_SWIPE:string = "blackSwipe";
    BETLINE_HIGHTLIGHT:string = "betlineHighlight1";
    BETLINE_HIGHTLIGHT_TINY:string = "betlineHighlightTiny1";

    NO_WIN_POSTER_SHIT:string = "noWinShit";
    NO_WIN_POSTER_NO_WIN:string = "noWinNoWin";
    NO_WIN_POSTER_BULLOCKS:string = "noWinBullocks";

    FS_MULTIPLIER_ADDED:string = "fsWildMulti";
    FS_EXTRASPINS_ADDED:string = "fsPlusOne";
    FS_LIGHTNING:string = "fsLightning";

    SIREN:string = "siren";

    EXPANDING_PLING:string = "pling1";


    constructor() {
        if(SoundConfig.instance) {
            throw new Error("SoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}